import { createApp } from 'vue'
import './styles/style.css'
import router from './util/router';
import Nav from './Nav.vue'
import Vue3Toastify from "vue3-toastify";


createApp(Nav).use(router).use(Vue3Toastify, {
	theme: 'dark',
	closeOnClick: true,
	hideProgressBar: !true,
	clearOnUrlChange: true,
	newestOnTop: true,
	pauseOnFocusLoss: true,
	pauseOnHover: false,
	transition: 'slide',
	position: 'top-right',
	autoClose: 5000,
}).mount('#app');

// Register service worker for token refresh
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/token-refresh-worker.js')
      .then(registration => {
        console.log('Token refresh service worker registered:', registration.scope);
      })
      .catch(error => {
        console.error('Service worker registration failed:', error);
      });
  });
  
  // Handle messages from service worker
  navigator.serviceWorker.addEventListener('message', (event) => {
    const { type } = event.data;
    
    if (type === 'GET_TOKEN_INFO') {
      const authToken = localStorage.getItem('auth_token');
      const expiresAt = localStorage.getItem('expiresAt');
      const refreshToken = localStorage.getItem('refresh_token');
      const refreshTokenExpiresAt = localStorage.getItem('refresh_token_expires');
      
      // Send token info back to service worker
      event.source.postMessage({
        type: 'TOKEN_INFO',
        tokenInfo: {
          authToken,
          expiresAt,
          refreshToken,
          refreshTokenExpiresAt
        }
      });
    }
    
    if (type === 'GET_REFRESH_INFO') {
      // Get the API URL and both tokens
      const apiUrl = import.meta.env.PUBLIC_API_URL;
      const refreshToken = localStorage.getItem('refresh_token');
      const authToken = localStorage.getItem('auth_token');
      
      // Send to service worker
      event.source.postMessage({
        type: 'REFRESH_INFO',
        refreshInfo: {
          apiUrl,
          refreshToken,
          authToken  // Now including the auth token
        }
      });
    }
    
    if (type === 'TOKEN_REFRESHED') {
      // Update tokens in localStorage
      const { token, expiresAt, refresh_token, refresh_token_expires } = event.data.tokenData;
      
      if (token) localStorage.setItem('auth_token', token);
      if (expiresAt) localStorage.setItem('expiresAt', expiresAt);
      
      // Update refresh token if provided
      if (refresh_token) {
        localStorage.setItem('refresh_token', refresh_token);
        
        if (refresh_token_expires) {
          localStorage.setItem('refresh_token_expires', refresh_token_expires);
        }
      }
      
      console.log('Auth token has been refreshed');
    }
    
    if (type === 'TOKEN_REFRESH_ERROR') {
      console.error('Token refresh failed:', event.data.error);
      
      // If token refresh repeatedly fails, may want to redirect to login
      // Implement retry logic or redirect based on your requirements
    }
  });
}
